export default "/Frontend/dist/event-background2-grey.d69bb5e95ecf8998a9c155f63261c632.svg";